module.exports = __webpack_public_path__ + "static/media/anc1ru.39a38e5b.pdf";